interface IAutoCompleteItem {
	readonly text: string;
	readonly value: unknown;
}

/**
 * The AutoCompleteItem is the "item" we use as the data provider in the AutoComplete component.
 *
 * Example:
 *
 * ```typescript
 * autoComplete.data = [new AutoCompleteItem({ text: 'The text we want to show', value: 'some value' }), new AutoCompleteItem({ text: 'Another text we want to show', value: false })];
 * ```
 */
export default class AutoCompleteItem implements IAutoCompleteItem {
	public get text(): string {
		return this.#text;
	}

	public get value(): unknown {
		return this.#value;
	}

	#text: string;
	#value: unknown;
	public constructor({ text, value }: IAutoCompleteItem) {
		assertIsString(text);
		this.#text = text;
		this.#value = value;
	}
}

function assertIsString(value: unknown): asserts value is string {
	if (typeof value === 'string') {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be of type string`);
}
